<script>
  import Button from './Button.svelte';
  import MessageBox from './MessageBox.svelte';
  import IconButton from './IconButton.svelte';
  import Common from '../js/common.js';

  export let display;
  export let message;
  export let onConfirm;
  export let messageBox = undefined;
  export let lang = undefined;

  document.addEventListener('keyup', event => {
    if (event.key === 'Escape') display = false;
  });

  const i18n = {
    yes: {
      cs: 'Ano',
      en: 'Yes',
    },
    no: {
      cs: 'Ne',
      en: 'No',
    },
  };
</script>

{#if display}
  <div class='confirm-modal'>
    <div class='confirm-modal-box'>
      <div class='confirm-modal-close'>
        <IconButton icon='close' onClick={() => { display = false; }} borderRadius='5px'/>
      </div>

      <div class='confirm-modal-box-content'>
        <div class='confirm-modal-box-content-message'>
          {@html Common.escapeHtml(message)}
        </div>

        {#if !messageBox}
          <div class='confirm-modal-box-content-button'>
            <div class='confirm-modal-box-content-button-yes'>
              <Button value={i18n.yes[lang]} onClick={onConfirm} icon='done' color='green'/>
            </div>

            <div class='confirm-modal-box-content-button-no'>
              <Button value={i18n.no[lang]} onClick={() => { display = false; }} icon='close' color='red'/>
            </div>
          </div>
        {:else}
          <div class='confirm-modal-box-content-message-box'>
            <MessageBox value={messageBox}/>
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  .confirm-modal {
    position: fixed;
    top: 0px;
    left: 0px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;

    z-index: 3;

    background: rgba(0, 0, 0, 0.8);
  }

  .confirm-modal-box {
    position: relative;

    width: 100%;
    max-width: 900px;

    margin: 40px 60px;

    border-radius: var(--radius-lg);

    background: var(--white);
  }

  .confirm-modal-close {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .confirm-modal-box-content {
    display: flex;
    flex-direction: column;
    gap: 20px;

    padding: 20px;
  }

  .confirm-modal-box-content-message {
    width: 100%;

    padding: 40px 0px;

    text-align: center;
  }

  .confirm-modal-box-content-button {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  .confirm-modal-box-content-button-yes {
    width: 100%;
  }

  .confirm-modal-box-content-button-no {
    width: 100%;
  }

  :global(body.dark) .confirm-modal-box {
    background: var(--grey-9);
  }

  @media only screen and (max-width: 900px) {
    .confirm-modal-box {
      margin: 40px;
    }
  }

  @media only screen and (max-width: 600px) {
    .confirm-modal-box-content-button {
      flex-direction: column;
    }
  }

  @media only screen and (max-width: 350px) {
    .confirm-modal-box {
      margin: 40px 20px;
    }
  }
</style>
